import { Quote } from "../../CRUDs/entities/Quote";
import { JobRequest } from "../../CRUDs/entities/JobRequest";
import { Customer } from "../../CRUDs/entities/Customer";
import { Visit } from "../../CRUDs/entities/Visit";
import { ApproveQuoteForm } from "../../customer-cab/ApproveQuoteForm";
import { checkActionAttribute } from "./checkActionAttribute";
import { Invoice } from "../../CRUDs/entities/Invoice";
import { SectionSwitcher } from "../SectionSwitcher";

export const quotesModalActionsListners = (target, actionsWindow, parents=null, context) => {

    const quoteId = target.parent().attr('data-id');
    const requestId = target.parent().attr('data-request-id');
    const customerId = target.parent().attr('data-customer-id');
    const invoiceId = target.parent().attr('data-invoice-id');

    const quote = new Quote(quoteId);
    const customer = new Customer(customerId);
    const request = new JobRequest(requestId);
    const staticVisit = new Visit();
    const invoice = new Invoice(invoiceId);

    checkActionAttribute([
       // { attribute: 'data-request-convertable', className: 'convert-to-job' },
        { attribute: 'data-need-approve',        className: 'approve-quote' },
        { attribute: ['data-editable', 'data-customer-active'],            className: 'edit-quote' },
        { attribute: 'data-has-no-invoice',      className: 'convert-to-invoice' },
        { attribute: 'data-invoice-id',          className: 'view-invoice' },
        { attribute: 'data-has-no-invoice',      className: 'turn-to-invoice' },
        { attribute: 'data-allow-reject',        className: 'reject-quote' },
        { attribute: 'data-customer-active',     className: 'create-visit' },

        { attribute: 'data-customer-active',     className: 'convert-to-invoice' },
        { attribute: 'data-allow-reject',     className: 'cancel-request' },
        { attribute: 'data-customer-active',     className: 'turn-to-invoice' },
        { attribute: 'data-customer-active',     className: 'convert-to-invoice' },
        { attribute: 'data-customer-active',     className: 'contact' },
        { attribute: [
            'data-customer-active',
            //'data-view-quote'
            ],                                   className: 'view-quote' },
        { attribute: 'data-customer-active',     className: 'to-pdf' },


    ], target, actionsWindow, parents);

    actionsWindow.find('.action').off();

    // contact customer
    actionsWindow.find('.action.contact').on('click', (e) => {
        customer.openModal('contact');
    });

    //view quote details
    actionsWindow.find('.action.view-quote').on('click', (e) => {
        quote.openModal('view');
    });

    // convert to job
   /* actionsWindow.find('.action.convert-to-job').on('click', (e) => {
        request.convertToJob();
        SectionSwitcher.updateSection('jobs');
    });*/

    // edit quote
    actionsWindow.find('.action.edit-quote').on('click', (e) => {
        window.open(`${window.location.origin}/jobs-flow/quote/${quoteId}/edit`, '_blank');
    });

    // cancel request
    actionsWindow.find('.action.cancel-request').on('click', (e) => {
        context.showOrHide(actionsWindow, target);
        request.changeStatus('cancel');
        quote.changeStatus('rejected', ()=>{
            SectionSwitcher.updateSection('quotes');
        });
    });

    // schedule a visit visit
    actionsWindow.find('.action.create-visit').on('click', (e) => {
        staticVisit.openModal('create', { job_request_id: request.id });
    });

    // view logs
    actionsWindow.find('.action.view-logs').on('click', (e) => {
        quote.openModal('logs');
    });

    // approve quote
    actionsWindow.find('.action.approve-quote').on('click', (e) => {
        ApproveQuoteForm.init(quote);
    });

    // convert to invoice
    actionsWindow.find('.action.convert-to-invoice').on('click', (e) => {
        quote.convertToInvoice();
        SectionSwitcher.updateSection('invoices');
    });

    // turn to invoices
    actionsWindow.find('.action.turn-to-invoice').on('click', (e) => {
        window.open(`${window.location.origin}/jobs-flow/invoice/create?quote_id=${quoteId}`, '_blank');
    });

    // to PDF
    actionsWindow.find('.action.to-pdf').attr('href', `/jobs-flow/quote/${quote.id}/pdf`);

    //reject quote
    actionsWindow.find('.action.reject-quote').on('click', (e) => {
        quote.openModal('reject');
        const confirmModal = $('#confirm-action-modal');

        confirmModal
            .modal('show')
            .find('button[data-confirmation]')
            .on('click', function(e) {
                quote.changeStatus('rejected');
                confirmModal.modal('hide');
                window.location.reload();
            });

    });
}
